import { Bar } from "react-chartjs-2";
import { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import axios from "axios";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function GraficaIngresosVsGastos({mes}) {
  const [datos, setDatos] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_DOMINIO}/wp-json/finanzas/v1/resumen/mensual?mes=${mes}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
      .then(res => {
        if (res.data.success) {
          setDatos(res.data.data);
        }
      })
      .catch(err => console.error(err));
  }, [mes]);

  if (!datos) return <p>Cargando comparativa...</p>;

  const meses = Object.keys(datos);
  const ingresos = meses.map(m => datos[m].ingresos || 0);
  const gastos = meses.map(m => datos[m].gastos || 0);

  const chartData = {
    labels: meses,
    datasets: [
      {
        label: "Ingresos",
        data: ingresos,
        backgroundColor: "#4BC0C0",
      },
      {
        label: "Gastos",
        data: gastos,
        backgroundColor: "#FF6384",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
    },
  };

  return (
    <div style={{ maxWidth: "800px", margin: "2rem auto" }}>
      <h3 style={{ textAlign: "center" }}>Ingresos vs Gastos</h3>
      <Bar data={chartData} options={options} />
    </div>
  );
}
